import React, { useMemo, useState } from 'react';

import { useDeletePeriodicityMutation } from 'src/redux/services/centralApi';
import { type Periodicity } from 'src/interfaces/entities/periodicity';
import { DeleteOutlined } from '@ant-design/icons';
import { Button, Flex, Modal, Tooltip } from 'antd';
import { toast } from 'react-toastify';

export default function DeleteCron(
	{
		row,
	}: { row: Periodicity<'persisted'> }
) {
	const [ open, setOpen, ] = useState<boolean>(false);

	const [ deletePeriodicity, deletePeriodicityResult, ] = useDeletePeriodicityMutation();

	const disabled = useMemo(() => {
		return row.org_id === null;
	}, [ row, ]);

	return <>
		<Tooltip
			title={
				disabled && 'Periodicidades padrões não podems ser deletadas.'
			}
		>
			<Button
				type='text'
				disabled={disabled}
				onClick={() => setOpen(true)}
				icon={<DeleteOutlined />}
			/>
		</Tooltip>
		<Modal
			centered
			title={'Excluir Severidade'}
			open={open}
			onCancel={() => {
				setOpen(false);
				toast.info('Operação cancelada!', { autoClose: 1000, });
			}}
			destroyOnHidden
			okText="Excluir"
			onOk={() => {
				deletePeriodicity(row.periodicity_id)
					.unwrap()
					.then(() => {
						toast.success('Severidade excluída com sucesso!', {
							autoClose: 1000,
						});
					})
					.catch((err) => {
						if (err?.status && err?.status === 500
							&& err?.data?.frontend_message) {
							toast.error(err?.data?.frontend_message, {
								autoClose: 1000,
							});
						}
					})
					.finally(() => {
						setOpen(false);
					});
			}}
			confirmLoading={deletePeriodicityResult.isLoading}
		>
			<Flex>
				{`Tem certeza que deseja deletar o cron: ${row.alias}`}
			</Flex>
		</Modal>
	</>;
}